import { Button, DatePicker, Form, Input, Segmented } from "antd";
import React, { useState } from "react";
import { useTransportOrderForm } from "../store/_context";
import { FormProvider } from "../../../common/provider/form/Form.provider";
import { TransportOrderService } from "../core/_request";
import { HttpStatusCode } from "axios";
import { SimpleInput } from "../../../common/components/simpleInput";
import { InputSelect } from "../../../common/components/InputSelect/InputSelect";
import { API_URLs } from "../../../utilities/API_URLs";
import { CustomButton } from "../../../common/components/CustomButton/CustomButton";
import dayjs from "dayjs";
import { OrderTransportConstant } from "../core/_constant";
import { RangePickerProps } from "antd/es/date-picker";
import { CgPlayTrackPrev } from "react-icons/cg";
import { GlobalRequest } from "../../../common/services/request";
import "./style.scss";

export const AssignationOT = () => {
  const [form] = Form.useForm();
  const { initialValue, otData, handlePrev, onFinish } =
    useTransportOrderForm();

  const defaultOtValue = { ...initialValue, ...otData };
  const isAssigned =
    defaultOtValue?.transportOrderState &&
    defaultOtValue?.transportOrderState?.id === OrderTransportConstant.ASSIGNED;
  const [isLoadingSubmit, setIsLoadingSubmit] = useState<boolean>(false);

  const onSubmitHandler = async (values: any) => {
    const { ...data } = values;

    try {
      const dataToPost = {
        ...data,
        ...(data?.deliveryDate
          ? {
              deliveryDate: dayjs(data?.deliveryDate).format(
                "YYYY-MM-DD HH:mm"
              ),
            }
          : {}),
        ...(data?.emptyTCrecoveryDate
          ? {
              emptyTCrecoveryDate: dayjs(data?.emptyTCrecoveryDate).format(
                "YYYY-MM-DD HH:mm"
              ),
            }
          : {}),
          ...(vehicleType === 'Interne' && {
            ...(data?.truck
              ? {
                  truck: data?.truck?.value,
                  vehicleType: "/api/vehicle_types/INTERNAL",
                }
              : {}),
          }),        
          ...(vehicleType === 'Particulier' && {
            vehicleType: "/api/vehicle_types/PARTICULAR"
          }),
      };
      setIsLoadingSubmit(true);

      const res = await TransportOrderService.assignOTToTruck(
        defaultOtValue?.id,
        dataToPost
      );

      if (
        res?.status === HttpStatusCode.Ok ||
        res?.status === HttpStatusCode.Created
      ) {
        onFinish();
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoadingSubmit(false);
    }
  };

  const disabledDate: RangePickerProps["disabledDate"] = (current) => {
    return current && current < dayjs().endOf("day").add(-1, "day");
  };

  type VehicleType = 'Interne' | 'Particulier'
  const [vehicleType, setVehicleType] = React.useState<VehicleType>(defaultOtValue?.vehicleType?.name  ?? 'Interne');

  const onTruckChange = async (truck: any) => {
    form.setFieldsValue({ driver: "" });
    try {
      const res = await GlobalRequest.get(truck.value);
      if (res?.status === HttpStatusCode.Ok) {
        form.setFieldsValue({
          driver: res?.data?.driver?.fullname ?? "",
        });
      }
    } catch (e) {
      console.log(e);
    }
  };

  return (
    <div>
      <div>
        <span className="details__vehicle_type_container"> Type de véhicule<br/></span>
        <Segmented
          value={vehicleType}
          className="segmented_blue_soft"
          //style={{ marginBottom: 8, marginTop: 2 }}
          style={{
            marginBottom: 8,
            marginTop: 2
          }}
          onChange={
            (value) => {
              if (!(defaultOtValue?.truck || defaultOtValue?.particularTruckNumber)) {
                setVehicleType(value as VehicleType);
              }
            }
          }
          options={['Interne', 'Particulier']}
        />
      </div>
      <FormProvider
        Form={Form}
        form={form}
        debug={true}
        initialValues={{
          ...defaultOtValue,
          ...(defaultOtValue?.truck
            ? {
                truck: {
                  label: defaultOtValue?.truck?.reference,
                  value: defaultOtValue?.truck?.["@id"],
                },
                driver: defaultOtValue?.truck?.driver?.fullname,
              }
            : {}),
          ...(defaultOtValue?.deliveryDate
            ? {
                deliveryDate: dayjs(
                  defaultOtValue?.deliveryDate,
                  "DD/MM/YYYY HH:mm"
                ),
              }
            : {}),
          ...(defaultOtValue?.emptyTCrecoveryDate
            ? {
                emptyTCrecoveryDate: dayjs(
                  defaultOtValue?.emptyTCrecoveryDate,
                  "DD/MM/YYYY HH:mm"
                ),
              }
            : {}),
        }}
        onFinish={onSubmitHandler}
        onFinishFailed={(err) => {
          console.log("err", err);
        }}
      >
        { vehicleType === "Interne" ? (
          <div className="d-flex gap-4 mt-2">
          <div className="w-100">
            <SimpleInput
              Form={Form}
              label="Camion"
              name={"truck"}
              rules={[
                {
                  required: true,
                  message: `Ce champ est requis`,
                },
              ]}
              customInput={
                <InputSelect
                  uri={`${API_URLs.transports.selectTruckToAssign}`}
                  params={{
                    machineMaterialType: "TRUCK",
                    materialFrom: "SEMS",
                  }}
                  valueOption={{
                    labelKey: "reference",
                    valueKey: "@id",
                  }}
                  disabled={isAssigned || defaultOtValue?.truck }
                  onChange={onTruckChange}
                />
              }
            />
          </div>
          <div className="w-100">
            <SimpleInput
              Form={Form}
              label="Chauffeur"
              name={"driver"}
              customInput={<Input readOnly disabled={isAssigned || defaultOtValue?.truck }/>}
            />
          </div>
        </div>
        ) : (
          <div className="d-flex gap-4 mt-2">
          <div className="w-100">
            <SimpleInput
              Form={Form}
              label="Camion"
              name={"particularTruckNumber"}
              rules={[
                {
                  required: true,
                  message: `Ce champ est requis`,
                },
              ]}
              customInput={<Input disabled={defaultOtValue?.particularTruckNumber}/>}
            />
          </div>
          <div className="w-100">
            <SimpleInput
              Form={Form}
              label="Chauffeur"
              name={"particularDriverName"}
              rules={[
                {
                  required: true,
                  message: `Ce champ est requis`,
                },
              ]}
              customInput={<Input disabled={defaultOtValue?.particularDriverName}/>}
            />
          </div>
        </div>
        )}
        <hr className="details__line"/>

        <div className="d-flex gap-4 mt-2">
          <div className="w-100">
            <SimpleInput
              Form={Form}
              label="Date de livraison"
              name={"deliveryDate"}
              rules={[
                {
                  required: true,
                  message: `Ce champ est requis`,
                },
              ]}
              customInput={
                <DatePicker
                  className="w-100"
                  showNow={false}
                  showTime
                  placeholder=""
                  format={"DD/MM/YYYY HH:mm"}
                  disabledDate={disabledDate}
                />
              }
            />
          </div>
          <div className="w-100">
            <SimpleInput
              Form={Form}
              label="Lieu de livraison"
              name={"deliveryLocation"}
              rules={[
                {
                  required: true,
                  message: `Ce champ est requis`,
                },
              ]}
              customInput={<Input />}
            />
          </div>
        </div>

        <div className="d-flex gap-4 mt-2">
          <div className="w-100">
            <SimpleInput
              Form={Form}
              label="Date de restitution du conteneur vide"
              name={"emptyTCrecoveryDate"}
              rules={[
                {
                  required: true,
                  message: `Ce champ est requis`,
                },
              ]}
              customInput={
                <DatePicker
                  showNow={false}
                  className="w-100"
                  showTime
                  placeholder=""
                  disabledDate={disabledDate}
                  format={"DD/MM/YYYY HH:mm"}
                />
              }
            />
          </div>
          <div className="w-100"> </div>
        </div>

        <div className={"d-flex mt-4 justify-content-between gap-2"}>
          <Button size="small" variant="outlined" onClick={handlePrev}>
          <CgPlayTrackPrev
              style={{
                height: "15px",
                width: "15px",
              }}
            />
            <span
              style={{
                fontSize: "12px",
              }}
            >
              Précédent
            </span>
          </Button>
          <CustomButton
            type="submit"
            className={""}
            isLoading={isLoadingSubmit}
          >
            Enregistrer
          </CustomButton>
        </div>
      </FormProvider>
    </div>
  );
};
